import { MessageBroker } from "../../services/messageBrokerService";
import dayjs, { Dayjs } from "dayjs";

export type ActivityLog = {
    transactionDate: string,
    action: string,
    recordKey: string,
    subject: string,
    message: string,
    isException:boolean,
    error:string,
    level:string,
    isSent: boolean
}


const messageBroker = new MessageBroker();

const activityLog: ActivityLog[] = [];
let currentPolicyNumber = "";

export async function logActivityAsync(recordKey:string, log: ActivityLog) {
    if(log.action == "error_activity"){
        activityLog.push(log);
        await sendActivity(recordKey, true);
        return;
    }

    activityLog.push(log);
    
    if (recordKey !== "" && recordKey !== undefined && recordKey !== null) {
        var isChanged = currentPolicyNumber != recordKey;
        currentPolicyNumber = recordKey;

        await sendActivity(recordKey, isChanged);
    }
}


async function sendActivity(recordKey: string, isChanged: boolean) {


    var logsToSend = activityLog.filter(m=> { return !m.isSent});

    for (let item of logsToSend) {
        try{
            if(item.isSent){
                continue;
            }

            item.recordKey = recordKey;

            var result = await messageBroker.sendActivityAsync(item);
            }catch(err){
                console.log(err);
            }

            item.isSent=true;
    }
}

